import { useState, useEffect } from 'react';
import axios from 'axios';
import { Loader2, Calendar, User, FileText, Plus } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProcedureTimeline = ({ procedureId, token, onAddEvent }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (procedureId) {
            fetchEvents();
        }
    }, [procedureId]);

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${API}/procedures/${procedureId}/events`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setEvents(response.data);
        } catch (error) {
            console.error('Error fetching events:', error);
            toast.error('Error al cargar eventos');
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString, includeTime = true) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('es-MX', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: includeTime ? '2-digit' : undefined,
            minute: includeTime ? '2-digit' : undefined
        });
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center py-12">
                <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
            </div>
        );
    }

    return (
        <div className="bg-white rounded-lg border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900">Línea de Tiempo</h3>
                <Button size="sm" variant="outline" onClick={onAddEvent}>
                    <Plus className="h-4 w-4 mr-2" />
                    Registrar Evento
                </Button>
            </div>

            {events.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                    <Calendar className="h-12 w-12 text-gray-300 mx-auto mb-4" />
                    <p>No hay eventos registrados</p>
                    <p className="text-sm mt-2">Los cambios de estado y actualizaciones aparecerán aquí</p>
                </div>
            ) : (
                <div className="relative border-l border-gray-200 ml-3 space-y-8">
                    {events.map((event, index) => (
                        <div key={event.id || index} className="mb-8 ml-6 relative">
                            {/* Dot */}
                            <span className="absolute -left-[31px] flex h-4 w-4 items-center justify-center rounded-full bg-white border-2 border-indigo-500 ring-4 ring-white"></span>

                            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start group">
                                <div className="flex-1">
                                    <h4 className="text-sm font-semibold text-gray-900">{event.title}</h4>
                                    {event.description && (
                                        <p className="mt-1 text-sm text-gray-600">{event.description}</p>
                                    )}
                                    <div className="mt-2 flex items-center gap-4 text-xs text-gray-500">
                                        <span className="flex items-center gap-1">
                                            <Calendar className="h-3 w-3" />
                                            {formatDate(event.event_date, false)}
                                        </span>
                                        <span className="flex items-center gap-1">
                                            <User className="h-3 w-3" />
                                            Usuario: {event.created_by_user_id ? event.created_by_user_id.slice(0, 8) : 'Sistema'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
